import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    path : '',
    language : 'zh-tw',
    languageList : [
        { value: 'en', name: 'EN' },
        { value: 'zh-tw', name: '繁' },
        { value: 'zh', name: '简' },
        // { value: 'ko', name: 'Korean' },
        // { value: 'vi', name: 'Vietnamese' }
    ]
}

const LanguageSlice = createSlice({
    name : 'language',
    initialState,
    reducers : {
        changeLanguage : (state, action) => {
            state.language = action.payload
        },
        changePath : (state, action) => {
            console.log(action.payload)
            state.path = action.payload
        },
    }

})

export const { changeLanguage, changePath } = LanguageSlice.actions

export default LanguageSlice.reducer